import { ReptoolApp } from './components/ReptoolApp.tsx';
import { Toolbar } from './components/utilities/Toolbar.tsx';
import { ErrorBoundary } from './components/ErrorBoundary.tsx';
import { LoadingOrModal } from './components/collection/modals/CollectionReptileModal.tsx';
import { AvailableList } from './components/store/AvailableList.tsx';
import { FixedCalendarPopup } from './components/utilities/FixedCalendarPopup.tsx';
import { ReptileSelector } from './components/utilities/ReptileSelector.tsx';
import { PostHogProvider } from 'posthog-js/react';
import { RepToolProviderWrapper } from './RepToolContext.tsx';
const ErrorBoundaryFallback = () => {
  return (
    <div className="error-boundary px-3 mt-5 text-center d-flex flex-column justify-content-center">
      <h1 className='mt-5'>Something went wrong</h1>
      <p>We appologize for the inconvenience. This error has been reported and will be taken care of as soon as possible. </p>
      <p>You may need to check for the latest update if there is one.</p>
      <p>In the meantime you can press the button below and reload the app.</p>
      <div className="mt-3">
        <button className="btn btn-outline-light-blue btn-lg" onClick={() => window.location.reload()}>Reload</button>
      </div>
    </div>
  )
}


const App = () => {
  return (
    <Wrapper>
      <ReptileSelector />
      <FixedCalendarPopup />
      <ReptoolApp />
    </Wrapper>
  );
}
export const CollectionReptileViewer = ({ reptileId, userId }) => {
  return (
    <Wrapper>
      <div className="container px-0 h-100">
        <LoadingOrModal reptileId={reptileId} userId={userId} />
      </div>
      <FixedCalendarPopup />
      <ReptileSelector />
      <Toolbar />
    </Wrapper>
  )

}

export const AvailableReptileViewer = ({ userId, backToMenu }) => {
  return (
    <Wrapper>
      <div className="container px-0 h-100">
        <AvailableList userId={userId} backToMenu={backToMenu} />
      </div>
      <FixedCalendarPopup />
      <ReptileSelector />
      <Toolbar />
    </Wrapper>
  )
}

const Wrapper = ({ children }) => {
  return (
    <RepToolProviderWrapper>
      <PostHogProvider apiKey={"phc_yvRswOJGAvD4Fs61nUEdkYtu8KACpttntllDrhiBxgI"} options={{ api_host: 'https://us.i.posthog.com' }}>
        <ErrorBoundary fallback={<ErrorBoundaryFallback />}>
          {children}
        </ErrorBoundary>
      </PostHogProvider>
    </RepToolProviderWrapper>
  )
}


export default App;
